<!--=============================
=            BUTTONS            =
==============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Buttons</div>
      </base-header>
    </v-row>
    <v-row>


      <v-col cols="12" md="6" sm="12">
        <base-card>
          <div slot="card-header">

            #Sizing

          </div>
          <div slot="card-subheader">Buttons can be given different sizing options to fit a multitude of scenarios.
          </div>

          <div slot="card-body">
            <v-container fluid class="pa-0">
              <v-row align="center">
                <v-col cols="12" sm="6">
                  <div class="text-center">
                    <div class="my-2">
                      <v-btn x-small color="secondary" dark>
                        Extra small Button
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn small color="primary" dark>
                        Small Button
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="warning" dark>
                        Normal Button
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="error" dark large>
                        Large Button
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn x-large color="success" dark>
                        Extra large Button
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="text-center">
                    <div class="my-2">
                      <v-btn color="secondary" fab x-small dark>
                        <v-icon>mdi-television</v-icon>
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="primary" fab small dark>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="warning" fab dark>
                        <v-icon>mdi-account-circle</v-icon>
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="error" fab large dark>
                        <v-icon>mdi-alarm</v-icon>
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn color="success" fab x-large dark>
                        <v-icon>mdi-domain</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <base-card>
          <div slot="card-header"> #Icon </div>
          <div slot="card-subheader">
            Icons can be used for the primary content of a button. This property makes the button rounded and applies
            the text prop styles. </div>
          <div slot="card-body">
            <v-card color="transparent" flat>
              <v-card-text>
                <v-container fluid class="transparent pb-5">
                  <v-row>
                    <v-col cols="12">
                      <p class="white--text">Normal</p>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon color="pink">
                        <v-icon>mdi-heart</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon color="indigo">
                        <v-icon>mdi-star</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon color="green">
                        <v-icon>mdi-cached</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon color="deep-orange">
                        <v-icon>mdi-thumb-up</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row class="mt-12">
                    <v-col cols="12">
                     <p class="white--text">Disabled</p>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon disabled>
                        <v-icon>mdi-heart</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon disabled>
                        <v-icon>mdi-star</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon disabled>
                        <v-icon>mdi-cached</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-btn icon disabled>
                        <v-icon>mdi-thumb-up</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>




      <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">

            #Floating
          </div>
          <div slot="card-subheader">

            Floating buttons are rounded and usually contain an icon.

          </div>
          <div slot="card-body">
            <div class="text-center">
              <v-btn class="mx-2" fab dark small color="primary">
                <v-icon dark>
                  mdi-minus
                </v-icon>
              </v-btn>

              <v-btn class="mx-2" fab dark small color="pink">
                <v-icon dark>
                  mdi-heart
                </v-icon>
              </v-btn>

              <v-btn class="mx-2" fab dark color="indigo">
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>

              <v-btn class="mx-2" fab dark color="teal">
                <v-icon dark>
                  mdi-format-list-bulleted-square
                </v-icon>
              </v-btn>

              <v-btn class="mx-2" fab dark large color="cyan">
                <v-icon dark>
                  mdi-pencil
                </v-icon>
              </v-btn>

              <v-btn class="mx-2" fab dark large color="purple">
                <v-icon dark>
                  mdi-android
                </v-icon>
              </v-btn>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">

            #Loaders

          </div>
          <div slot="card-subheader">

            Using the loading prop, you can notify a user that there is processing taking place. The default behavior is
            to use a v-progress-circular component but this can be customized.
          </div>
          <div slot="card-body">
            <div class="text-center">
              <v-btn class="ma-2" :loading="loading" :disabled="loading" color="secondary" @click="loader = 'loading'">
                Accept Terms
              </v-btn>

              <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" class="ma-2 white--text"
                     @click="loader = 'loading3'">
                Upload
                <v-icon right dark>
                  mdi-cloud-upload
                </v-icon>
              </v-btn>

              <v-btn class="ma-2" :loading="loading2" :disabled="loading2" color="success" @click="loader = 'loading2'">
                Custom Loader
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>

              <v-btn class="ma-2" :loading="loading4" :disabled="loading4" color="info" @click="loader = 'loading4'">
                Icon Loader
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <v-btn :loading="loading5" :disabled="loading5" color="blue-grey" class="ma-2 white--text" fab
                     @click="loader = 'loading5'">
                <v-icon dark>
                  mdi-cloud-upload
                </v-icon>
              </v-btn>
            </div>
          </div>
        </base-card>
      </v-col>


</v-row>

</div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
      }
    },
    watch: {
      loader() {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },

  }
</script>
<style>

</style>

<!--====  End of BUTTONS  ====-->